import { ArtAssetType } from '@do/models';

import type { FormValues, ArtworksFiltersModel } from '../types';
import { ArtworkViewMode } from './options';

export const defaultValues: FormValues = {
  art_asset_type: `${ArtAssetType.DigitalCommon},${ArtAssetType.DigitalOriginal}`,
  artists_slugs: [],
  curators_slugs: [],
  styles_slugs: [],
  medium_slugs: [],
  countries_slugs: [],
  token_status: ArtworkViewMode.All,
  price: [0, 0],
  creation_year: [0, 0],
  original_size_x: [0, 0],
  original_size_y: [0, 0],
  curator_review: false,
};

export const defaultsData: ArtworksFiltersModel = {
  initialized: false,
  initialValues: defaultValues,
  updatedValues: defaultValues,
  values: defaultValues,
  options: {
    art_asset_type: [],
    artists: [],
    curators: [],
    styles: [],
    medium: [],
    countries: [],
    token_status: [],
    price: [0, 0],
    creation_year: [0, 0],
    original_size_x: [0, 0],
    original_size_y: [0, 0],
    curator_review: false,
  },
  currentOption: {},
  items_total_count: 0,
};
